/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContentZoneContext } from "cms/components/context";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerTipTap, useConvertQuillToTiptap } from "cms/rich-text/simplicity-composer-tiptap";
import DebugJSON from "components/debug_json";
import Config from "data/config";

const RichTextTipTapComponentEditor = () => {
    
    const { expanded } = useContentZoneContext();
    const { updateFactory } = useUpdateComponent();
    const { tiptapContent } = useConvertQuillToTiptap();
    
    const onChange = updateFactory("richtext");

    // performance hack to prevent the editor from instantiating when the
    // accordion is closed
    if (!expanded) {
        return null;
    }
    
    return (
        <div className='simplicity-editor-frame'>
            <SimplicityComposerTipTap
                onChange={onChange}
                richtext={tiptapContent}
            />
            {Config.Debug.useRichTextDebug &&
                <DebugJSON name='Show' json={tiptapContent} />
            }
        </div>
    );
};

RichTextTipTapComponentEditor.displayName = "RichTextTipTapComponentEditor";
export { RichTextTipTapComponentEditor };
